import { render } from "./LocataireDetailsPage.vue?vue&type=template&id=63a141dc"
import script from "./LocataireDetailsPage.vue?vue&type=script&lang=js"
export * from "./LocataireDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__